import { FC } from "react";
import ShareIconSVG from "../../svg/ShareIconSVG";
import { useTranslation } from "react-i18next";

interface ShareButtonProps {
    onClick: () => void;
}

const ShareButton: FC<ShareButtonProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center tmax4:mr-5 cursor-pointer group" onClick={props.onClick}>
            <ShareIconSVG className="w-[32px] dmax2:w-[24px] mr-2 dmax2:mr-1 text-textFaded group-hover:text-textWhite transition duration-300" />
            <span className="H14 dmax2:H14B text-textFaded group-hover:text-textWhite transition duration-300">
                {t("common.share")}
            </span>
        </div>
    );
};

export default ShareButton;
